import { Routes } from "@angular/router";

export const contractsLazyRouting: Routes = [
  {
    path: "",
    loadComponent: () => import("./contracts.component").then((c) => c.ContractsComponent),
  },
];
